import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  CircularProgress,
} from "@mui/material";
import type { TemplateApiItem } from "../types/api-types";

interface TemplateApiDeleteDialogProps {
  open: boolean;
  api: TemplateApiItem | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const TemplateApiDeleteDialog = ({
  open,
  api,
  isDeleting,
  onCancel,
  onConfirm,
}: TemplateApiDeleteDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the API endpoint &quot;
          {api?.endpoint}&quot;? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
        >
          {isDeleting ? <CircularProgress size={20} /> : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplateApiDeleteDialog;
